import { getCollectionIdPrefix } from 'utils/text';

export const getNewPageId = (property: string): string =>
  `${getCollectionIdPrefix()}${property.toUpperCase()}_BASELINE`;
